import { render, staticRenderFns } from "./variation.vue?vue&type=template&id=1c07d1a9&scoped=true"
import script from "./variation.vue?vue&type=script&lang=js"
export * from "./variation.vue?vue&type=script&lang=js"
import style0 from "./variation.vue?vue&type=style&index=0&id=1c07d1a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07d1a9",
  null
  
)

export default component.exports